<template>
  <component
    class="ocean-ui-common-component"
    :is="tagName || 'div'"
    type="button"
    :class="[classes, pointClass]"
    @click="passMethod('click')"
    @blur="passMethod('blur')"
    @focus="passMethod('focus')"
    @change="passMethod('change')"
  >
    <slot></slot>
  </component>
</template>

<script>
import themeMixins from '../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['tagName'],
};
</script>

<style scoped lang="scss">
.ocean-ui-common-component {
  cursor: pointer;
}
</style>
